__webpack_require__.p = "/Bddy/";